module.exports = __webpack_public_path__ + "static/media/Location-gray.e0e4acc6.svg";